(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["digital-planner-page"] && !Shopify.designMode) return;
  try {
    
  (() => {
    document.querySelectorAll('[data-ssdp]').forEach((root) => {
      if (root.dataset.ssdpReady === 'true') return;
      root.dataset.ssdpReady = 'true';

      const createArt = (key, title) => {
        const template = root.querySelector(`template[data-ssdp-template="${key}"]`);
        if (template) return template.content.cloneNode(true);

        const art = document.createElement('div');
        art.className = `ssdp-concept ssdp-concept--${key}`;

        const side = document.createElement('div');
        side.className = 'ssdp-concept__side';

        const heading = document.createElement('strong');
        heading.className = 'ssdp-concept__title';
        heading.textContent = title;

        const cards = document.createElement('div');
        cards.className = 'ssdp-concept__cards';
        for (let index = 0; index < 3; index += 1) cards.appendChild(document.createElement('i'));

        art.append(side, heading, cards);
        const fragment = document.createDocumentFragment();
        fragment.appendChild(art);
        return fragment;
      };

      const renderArt = (target, key, title) => {
        if (!target) return;
        target.replaceChildren(createArt(key, title));
      };

      root.querySelectorAll('[data-ssdp-art]').forEach((target) => {
        renderArt(target, target.dataset.ssdpArt, target.dataset.artTitle || 'Planner feature');
      });

      const explorerStage = root.querySelector('[data-ssdp-explorer-stage]');
      const explorerTabs = Array.from(root.querySelectorAll('[data-ssdp-tab]'));
      const explorerTimeline = root.querySelector('.ssdp-view-timeline');
      const explorerPrevious = root.querySelector('[data-ssdp-explorer-previous]');
      const explorerNext = root.querySelector('[data-ssdp-explorer-next]');
      const explorerCurrent = root.querySelector('[data-ssdp-explorer-current]');
      const explorerCopy = root.querySelector('[data-ssdp-explorer-copy]');
      const activateExplorer = (tab, focusTab = false) => {
        if (!tab || !explorerStage) return;
        const activeIndex = explorerTabs.indexOf(tab);
        explorerTabs.forEach((item) => item.setAttribute('aria-selected', item === tab ? 'true' : 'false'));
        if (explorerCurrent) explorerCurrent.textContent = String(activeIndex + 1).padStart(2, '0');
        if (explorerPrevious) explorerPrevious.disabled = activeIndex === 0;
        if (explorerNext) explorerNext.disabled = activeIndex === explorerTabs.length - 1;
        if (explorerCopy) explorerCopy.textContent = tab.dataset.ssdpCopy || '';
        explorerStage.classList.add('is-changing');
        window.setTimeout(() => {
          renderArt(explorerStage, tab.dataset.ssdpTab, `${tab.textContent.trim()} planner page`);
          explorerStage.setAttribute('aria-label', `${tab.textContent.trim()} planner page preview`);
          explorerStage.classList.remove('is-changing');
        }, 120);
        if (explorerTimeline) {
          const tabBox = tab.getBoundingClientRect();
          const timelineBox = explorerTimeline.getBoundingClientRect();
          explorerTimeline.scrollBy({
            left: tabBox.left - timelineBox.left - (timelineBox.width - tabBox.width) / 2,
            behavior: 'smooth'
          });
        }
        if (focusTab) tab.focus();
      };

      explorerTabs.forEach((tab, index) => {
        tab.addEventListener('click', () => activateExplorer(tab));
        tab.addEventListener('keydown', (event) => {
          let nextIndex = null;
          if (event.key === 'ArrowRight') nextIndex = (index + 1) % explorerTabs.length;
          if (event.key === 'ArrowLeft') nextIndex = (index - 1 + explorerTabs.length) % explorerTabs.length;
          if (event.key === 'Home') nextIndex = 0;
          if (event.key === 'End') nextIndex = explorerTabs.length - 1;
          if (nextIndex === null) return;
          event.preventDefault();
          activateExplorer(explorerTabs[nextIndex], true);
        });
      });

      if (explorerPrevious) {
        explorerPrevious.addEventListener('click', () => {
          const activeIndex = explorerTabs.findIndex((tab) => tab.getAttribute('aria-selected') === 'true');
          activateExplorer(explorerTabs[Math.max(0, activeIndex - 1)]);
        });
      }

      if (explorerNext) {
        explorerNext.addEventListener('click', () => {
          const activeIndex = explorerTabs.findIndex((tab) => tab.getAttribute('aria-selected') === 'true');
          activateExplorer(explorerTabs[Math.min(explorerTabs.length - 1, activeIndex + 1)]);
        });
      }

      if (explorerStage) {
        let swipeStartX = null;
        let swipeStartY = null;
        explorerStage.addEventListener('pointerdown', (event) => {
          if (event.pointerType === 'mouse') return;
          swipeStartX = event.clientX;
          swipeStartY = event.clientY;
        }, { passive: true });
        explorerStage.addEventListener('pointerup', (event) => {
          if (swipeStartX === null || swipeStartY === null) return;
          const deltaX = event.clientX - swipeStartX;
          const deltaY = event.clientY - swipeStartY;
          swipeStartX = null;
          swipeStartY = null;
          if (Math.abs(deltaX) < 45 || Math.abs(deltaX) <= Math.abs(deltaY)) return;
          const activeIndex = explorerTabs.findIndex((tab) => tab.getAttribute('aria-selected') === 'true');
          const nextIndex = deltaX < 0 ? activeIndex + 1 : activeIndex - 1;
          activateExplorer(explorerTabs[Math.min(explorerTabs.length - 1, Math.max(0, nextIndex))]);
        }, { passive: true });
      }
      activateExplorer(explorerTabs[0]);

      const verticalStories = Array.from(root.querySelectorAll('[data-ssdp-story]')).map((story) => {
        const stepsRail = story.querySelector('.ssdp-story__steps');
        const steps = Array.from(story.querySelectorAll('[data-ssdp-step]'));
        const stage = story.querySelector('[data-ssdp-story-art]');
        const stageShell = story.querySelector('.ssdp-story__stage');
        const caption = story.querySelector('.ssdp-story__stage-caption');
        const number = story.querySelector('[data-ssdp-story-number]');
        const title = story.querySelector('[data-ssdp-story-title]');
        const layers = [];
        let activeIndex = 0;
        let settleTimer = null;

        if (stage) {
          stage.replaceChildren();
          steps.forEach((step, index) => {
            const layer = document.createElement('div');
            layer.className = 'ssdp-story__stage-layer';
            renderArt(layer, step.dataset.art, step.dataset.title);
            if (index === 0) layer.classList.add('is-active');
            stage.append(layer);
            layers.push(layer);
          });
        }

        const activateStep = (index) => {
          const step = steps[index];
          if (!step || index === activeIndex) return;
          const previousIndex = activeIndex;
          activeIndex = index;
          steps.forEach((item, itemIndex) => item.classList.toggle('is-active', itemIndex === activeIndex));
          layers.forEach((layer, layerIndex) => {
            layer.classList.toggle('is-active', layerIndex === activeIndex);
            layer.classList.toggle('is-exiting', layerIndex === previousIndex && layerIndex !== activeIndex);
          });
          window.clearTimeout(settleTimer);
          settleTimer = window.setTimeout(() => {
            layers.forEach((layer) => layer.classList.remove('is-exiting'));
          }, 340);
          if (number) number.textContent = step.dataset.number;
          if (title) title.textContent = step.dataset.title;
          if (caption && typeof caption.animate === 'function' && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
            caption.getAnimations().forEach((animation) => animation.cancel());
            caption.animate([
              { opacity: .2, transform: 'translate3d(0, 4px, 0)' },
              { opacity: 1, transform: 'translate3d(0, 0, 0)' }
            ], { duration: 280, easing: 'cubic-bezier(.2,.65,.3,1)' });
          }
        };

        if (steps[0]) {
          steps.forEach((step, index) => step.classList.toggle('is-active', index === 0));
          steps[0].classList.add('is-active');
        }

        return { story, steps, stepsRail, stage, stageShell, activateStep };
      });

      let verticalFrame = null;
      let verticalMeasureFrame = null;

      const measureVerticalStories = () => {
        verticalMeasureFrame = null;
        verticalStories.forEach(({ story, steps, stepsRail, stage, stageShell }) => {
          if (!stepsRail) return;
          if (window.innerWidth <= 990 || !stage || !stageShell || !steps[0]) {
            stepsRail.style.removeProperty('--ssdp-first-step-offset');
            stepsRail.style.removeProperty('--ssdp-last-step-offset');
            return;
          }
          stepsRail.style.setProperty('--ssdp-first-step-offset', '0px');
          stepsRail.style.setProperty('--ssdp-last-step-offset', '0px');
          const stageHeight = stage.getBoundingClientRect().height;
          const stageShellHeight = stageShell.getBoundingClientRect().height;
          const firstStepHeight = steps[0].getBoundingClientRect().height;
          const lastStepHeight = steps[steps.length - 1].getBoundingClientRect().height;
          const firstStepOffset = Math.max(0, (stageHeight - firstStepHeight) / 2);
          const introHeight = story.querySelector('.ssdp-story__intro').getBoundingClientRect().height;
          const lastStepCenter = Math.max(stageHeight / 2, introHeight + 20 + lastStepHeight / 2);
          const lastStepOffset = Math.max(0, stageShellHeight - lastStepCenter - lastStepHeight / 2);
          stepsRail.style.setProperty('--ssdp-first-step-offset', `${firstStepOffset}px`);
          stepsRail.style.setProperty('--ssdp-last-step-offset', `${lastStepOffset}px`);
        });
        queueVerticalUpdate();
      };

      const updateVerticalStories = () => {
        verticalFrame = null;
        if (window.innerWidth <= 990) return;
        verticalStories.forEach(({ story, steps, stage, activateStep }) => {
          const storyBox = story.getBoundingClientRect();
          if (storyBox.bottom <= 0 || storyBox.top >= window.innerHeight) return;
          const stageBox = stage ? stage.getBoundingClientRect() : null;
          const introBox = story.querySelector('.ssdp-story__intro').getBoundingClientRect();
          const triggerLine = stageBox && stageBox.height > 0
            ? Math.max(stageBox.top + stageBox.height * .75, introBox.bottom + 20 + steps[0].getBoundingClientRect().height / 2)
            : window.innerHeight * .75;
          let activeIndex = 0;
          steps.forEach((step, index) => {
            const stepBox = step.getBoundingClientRect();
            const stepCenter = stepBox.top + stepBox.height / 2;
            if (stepCenter <= triggerLine) activeIndex = index;
          });
          activateStep(activeIndex);
        });
      };

      const queueVerticalUpdate = () => {
        if (verticalFrame !== null) return;
        verticalFrame = window.requestAnimationFrame(updateVerticalStories);
      };

      const queueVerticalMeasure = () => {
        if (verticalMeasureFrame !== null) return;
        verticalMeasureFrame = window.requestAnimationFrame(measureVerticalStories);
      };

      window.addEventListener('scroll', queueVerticalUpdate, { passive: true });
      window.addEventListener('resize', queueVerticalMeasure, { passive: true });
      window.requestAnimationFrame(measureVerticalStories);
      if (document.fonts && document.fonts.ready) document.fonts.ready.then(queueVerticalMeasure);


      const createMobileFeatureIcon = (key) => {
        const icon = document.createElement('span');
        icon.className = 'ssdp-mobile-feature__icon';
        icon.setAttribute('aria-hidden', 'true');
        icon.dataset.ssdpIcon = key;
        icon.dataset.ssIconFamily = "material-outlined-200";
        return icon;
      };

      const mobileAccordionRails = [
        ...Array.from(root.querySelectorAll('.ssdp-story__steps')),
        ...Array.from(root.querySelectorAll('[data-ssdp-horizontal-viewport]'))
      ];


      mobileAccordionRails.forEach((rail, railIndex) => {
        const items = rail.matches('.ssdp-story__steps')
          ? Array.from(rail.querySelectorAll(':scope > .ssdp-story__step'))
          : Array.from(rail.querySelectorAll('.ssdp-feature-card'));
        if (items.length < 2) return;

        const section = rail.closest('section');
        const heading = section ? section.querySelector('h2') : null;
        const label = heading ? (heading.innerText || heading.textContent).replace(/\s+/g, ' ').trim() : 'Planner features';
        const accordion = document.createElement('div');
        const accordionItems = [];
        accordion.className = 'ssdp-mobile-accordion';
        accordion.setAttribute('aria-label', `${label} features`);
        rail.classList.add('has-mobile-accordion');

        const openItem = (target, restoreFocus = false) => {
          accordionItems.forEach(({ item, button, panel, art, artKey, artTitle }) => {
            const isOpen = item === target;
            item.classList.toggle('is-open', isOpen);
            button.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
            panel.hidden = !isOpen;
            if (isOpen && !art.hasChildNodes()) renderArt(art, artKey, artTitle);
          });
          if (restoreFocus) target.querySelector('.ssdp-mobile-feature__trigger').focus({ preventScroll: true });
        };

        items.forEach((source, itemIndex) => {
          const titleNode = source.querySelector('h3');
          const paragraph = source.querySelector(':scope > p');
          const artSource = source.querySelector('[data-ssdp-art]');
          const statusNode = source.querySelector('.ssdp-feature-card__title-row small');
          if (!titleNode || !paragraph || !artSource) return;

          const title = titleNode.textContent.trim();
          const artKey = source.dataset.art || artSource.dataset.ssdpArt || 'templates';
          const iconKey = source.dataset.ssdpIcon;
          const artTitle = artSource.dataset.artTitle || title;
          const item = document.createElement('article');
          const button = document.createElement('button');
          const copy = document.createElement('span');
          const titleText = document.createElement('strong');
          const indicator = document.createElement('span');
          const panel = document.createElement('div');
          const art = document.createElement('div');
          const triggerId = `ssdp-mobile-feature-${railIndex + 1}-${itemIndex + 1}`;
          const panelId = `${triggerId}-panel`;

          item.className = 'ssdp-mobile-feature';
          button.className = 'ssdp-mobile-feature__trigger';
          button.type = 'button';
          button.id = triggerId;
          button.setAttribute('aria-expanded', itemIndex === 0 ? 'true' : 'false');
          button.setAttribute('aria-controls', panelId);
          copy.className = 'ssdp-mobile-feature__copy';
          titleText.textContent = title;
          copy.append(titleText);
          if (statusNode) {
            const status = document.createElement('small');
            status.textContent = statusNode.textContent.trim();
            copy.append(status);
          }
          indicator.className = 'ssdp-mobile-feature__indicator';
          indicator.setAttribute('aria-hidden', 'true');
          panel.className = 'ssdp-mobile-feature__panel';
          panel.id = panelId;
          panel.setAttribute('role', 'region');
          panel.setAttribute('aria-labelledby', triggerId);
          panel.hidden = itemIndex !== 0;
          art.className = 'ssdp-mobile-feature__art';
          panel.append(paragraph.cloneNode(true), art);
          button.append(createMobileFeatureIcon(iconKey), copy, indicator);
          item.append(button, panel);
          accordion.append(item);
          accordionItems.push({ item, button, panel, art, artKey, artTitle });
          button.addEventListener('click', () => openItem(item));
        });

        if (accordionItems[0]) openItem(accordionItems[0].item);
        rail.insertAdjacentElement('afterend', accordion);
      });

      const personalizeGrid = root.querySelector('.ssdp-personalize__grid');
      if (personalizeGrid) {
        const personalizeCards = Array.from(personalizeGrid.querySelectorAll(':scope > .ssdp-personalize__card'));
        if (personalizeCards.length) {
          const accordion = document.createElement('div');
          const accordionItems = [];
          accordion.className = 'ssdp-mobile-accordion ssdp-personalize__mobile-accordion';
          accordion.setAttribute('aria-label', 'Make it yours features');
          personalizeGrid.classList.add('has-mobile-accordion');

          const openItem = (target) => {
            accordionItems.forEach(({ item, button, panel, art, artKey, artTitle }) => {
              const isOpen = item === target;
              item.classList.toggle('is-open', isOpen);
              button.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
              panel.hidden = !isOpen;
              if (isOpen && !art.hasChildNodes()) renderArt(art, artKey, artTitle);
            });
          };

          personalizeCards.forEach((source, itemIndex) => {
            const titleNode = source.querySelector('.ssdp-personalize__copy h3');
            const paragraph = source.querySelector('.ssdp-personalize__copy p');
            const artSource = source.querySelector('[data-ssdp-art]');
            if (!titleNode || !paragraph || !artSource) return;

            const title = titleNode.textContent.trim();
            const artKey = artSource.dataset.ssdpArt || 'templates';
            const artTitle = artSource.dataset.artTitle || title;
            const item = document.createElement('article');
            const button = document.createElement('button');
            const copy = document.createElement('span');
            const titleText = document.createElement('strong');
            const indicator = document.createElement('span');
            const panel = document.createElement('div');
            const art = document.createElement('div');
            const triggerId = `ssdp-personalize-mobile-${itemIndex + 1}`;
            const panelId = `${triggerId}-panel`;

            item.className = 'ssdp-mobile-feature';
            button.className = 'ssdp-mobile-feature__trigger';
            button.type = 'button';
            button.id = triggerId;
            button.setAttribute('aria-expanded', itemIndex === 0 ? 'true' : 'false');
            button.setAttribute('aria-controls', panelId);
            copy.className = 'ssdp-mobile-feature__copy';
            titleText.textContent = title;
            copy.append(titleText);
            indicator.className = 'ssdp-mobile-feature__indicator';
            indicator.setAttribute('aria-hidden', 'true');
            panel.className = 'ssdp-mobile-feature__panel';
            panel.id = panelId;
            panel.setAttribute('role', 'region');
            panel.setAttribute('aria-labelledby', triggerId);
            panel.hidden = itemIndex !== 0;
            art.className = 'ssdp-mobile-feature__art';
            panel.append(paragraph.cloneNode(true), art);
            button.append(createMobileFeatureIcon(source.dataset.ssdpIcon), copy, indicator);
            item.append(button, panel);
            accordion.append(item);
            accordionItems.push({ item, button, panel, art, artKey, artTitle });
            button.addEventListener('click', () => openItem(item));
          });

          if (accordionItems[0]) openItem(accordionItems[0].item);
          personalizeGrid.insertAdjacentElement('afterend', accordion);
        }
      }

      const mobileRailEntries = [
        ...Array.from(root.querySelectorAll('.ssdp-story__steps')).map((rail) => ({
          rail,
          items: Array.from(rail.querySelectorAll(':scope > .ssdp-story__step')),
          host: rail.parentElement
        })),
        ...Array.from(root.querySelectorAll('[data-ssdp-horizontal-viewport]')).map((rail) => ({
          rail,
          items: Array.from(rail.querySelectorAll('.ssdp-feature-card')),
          host: rail.parentElement
        })),
        ...Array.from(root.querySelectorAll('.ssdp-anywhere__grid')).map((rail) => ({
          rail,
          items: Array.from(rail.querySelectorAll(':scope > article')),
          host: rail.parentElement
        }))
      ];

      mobileRailEntries.forEach(({ rail, items, host }, railIndex) => {
        if (!rail || !host || items.length < 2) return;

        const section = rail.closest('section');
        const heading = section ? section.querySelector('h2') : null;
        const label = heading ? (heading.innerText || heading.textContent).replace(/\s+/g, ' ').trim() : 'Planner features';
        rail.id = rail.id || `ssdp-mobile-rail-${railIndex + 1}`;
        rail.classList.add('is-mobile-carousel-ready');
        items[0].classList.add('is-mobile-active');
        rail.tabIndex = 0;
        rail.setAttribute('role', 'region');
        rail.setAttribute('aria-label', `${label} feature carousel`);

        const controls = document.createElement('div');
        controls.className = 'ssdp-mobile-controls';
        controls.setAttribute('aria-label', `${label} controls`);

        const previous = document.createElement('button');
        previous.type = 'button';
        previous.setAttribute('aria-label', 'Previous feature');
        previous.setAttribute('aria-controls', rail.id);
        previous.innerHTML = '<span aria-hidden="true"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" stroke="none" aria-hidden="true" focusable="false" data-ss-icon="arrow_back" ><g transform="translate(0 24) scale(.025)"><path d="m276.85-460 231.69 231.69L480-200 200-480l280-280 28.54 28.31L276.85-500H760v40H276.85Z"/></g></svg></span>';

        const meta = document.createElement('div');
        meta.className = 'ssdp-mobile-controls__meta';

        const hint = document.createElement('span');
        hint.className = 'ssdp-mobile-controls__hint';
        hint.textContent = 'Swipe to explore';

        const status = document.createElement('span');
        status.className = 'ssdp-mobile-controls__status';
        status.setAttribute('aria-live', 'polite');
        status.innerHTML = `<b>01</b><i aria-hidden="true">/</i><span>${String(items.length).padStart(2, '0')}</span>`;

        const progress = document.createElement('span');
        progress.className = 'ssdp-mobile-controls__progress';
        progress.setAttribute('aria-hidden', 'true');
        const progressSegments = items.map(() => {
          const segment = document.createElement('i');
          progress.append(segment);
          return segment;
        });

        const next = document.createElement('button');
        next.type = 'button';
        next.setAttribute('aria-label', 'Next feature');
        next.setAttribute('aria-controls', rail.id);
        next.innerHTML = '<span aria-hidden="true"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" stroke="none" aria-hidden="true" focusable="false" data-ss-icon="arrow_forward" ><g transform="translate(0 24) scale(.025)"><path d="M683.15-460H200v-40h483.15L451.46-731.69 480-760l280 280-280 280-28.54-28.31L683.15-460Z"/></g></svg></span>';

        const navigation = document.createElement('div');
        navigation.className = 'ssdp-mobile-controls__nav';
        meta.append(hint, status);
        navigation.append(previous, progress, next);
        controls.append(meta, navigation);
        rail.insertAdjacentElement('afterend', controls);

        let activeIndex = 0;
        let railFrame = null;
        const current = status.querySelector('b');

        const updateControls = () => {
          railFrame = null;
          const railBox = rail.getBoundingClientRect();
          const railCenter = railBox.left + railBox.width / 2;
          let nearestIndex = 0;
          let nearestDistance = Number.POSITIVE_INFINITY;
          items.forEach((item, index) => {
            const itemBox = item.getBoundingClientRect();
            const distance = Math.abs(itemBox.left + itemBox.width / 2 - railCenter);
            if (distance < nearestDistance) {
              nearestDistance = distance;
              nearestIndex = index;
            }
          });
          activeIndex = nearestIndex;
          if (current) current.textContent = String(activeIndex + 1).padStart(2, '0');
          items.forEach((item, index) => item.classList.toggle('is-mobile-active', index === activeIndex));
          progressSegments.forEach((segment, index) => segment.classList.toggle('is-active', index === activeIndex));
          previous.disabled = activeIndex === 0;
          next.disabled = activeIndex === items.length - 1;
        };

        const queueControlsUpdate = () => {
          if (railFrame !== null) return;
          railFrame = window.requestAnimationFrame(updateControls);
        };

        const moveTo = (index) => {
          const targetIndex = Math.min(items.length - 1, Math.max(0, index));
          const railBox = rail.getBoundingClientRect();
          const itemBox = items[targetIndex].getBoundingClientRect();
          rail.scrollBy({
            left: itemBox.left - railBox.left - (railBox.width - itemBox.width) / 2,
            behavior: 'smooth'
          });
        };

        previous.addEventListener('click', () => moveTo(activeIndex - 1));
        next.addEventListener('click', () => moveTo(activeIndex + 1));
        rail.addEventListener('scroll', queueControlsUpdate, { passive: true });
        rail.addEventListener('keydown', (event) => {
          if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
          event.preventDefault();
          moveTo(activeIndex + (event.key === 'ArrowRight' ? 1 : -1));
        });
        window.addEventListener('resize', queueControlsUpdate, { passive: true });
        window.requestAnimationFrame(updateControls);
      });

      const horizontalSections = Array.from(root.querySelectorAll('[data-ssdp-horizontal]'));
      const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      let horizontalFrame = null;
      let resizeTimer = null;

      const horizontalEnabled = () => window.innerWidth > 990 && !reducedMotion.matches;

      const updateHorizontal = () => {
        horizontalFrame = null;
        if (!horizontalEnabled()) return;

        horizontalSections.forEach((section) => {
          if (!section.classList.contains('is-scroll-linked')) return;
          const track = section.querySelector('[data-ssdp-horizontal-track]');
          const progressBar = section.querySelector('[data-ssdp-horizontal-progress]');
          const distance = Number(section.dataset.ssdpHorizontalDistance || 0);
          const sticky = section.querySelector('.ssdp-horizontal__sticky');
          const range = Math.max(1, section.getBoundingClientRect().height - sticky.getBoundingClientRect().height);
          const stickyTop = parseFloat(window.getComputedStyle(sticky).top) || 0;
          const progress = Math.min(1, Math.max(0, (stickyTop - section.getBoundingClientRect().top) / range));
          if (track) track.style.transform = `translate3d(${-distance * progress}px, 0, 0)`;
          if (progressBar) progressBar.style.transform = `scaleX(${.08 + progress * .92})`;
        });
      };

      const queueHorizontalUpdate = () => {
        if (horizontalFrame !== null) return;
        horizontalFrame = window.requestAnimationFrame(updateHorizontal);
      };

      const measureHorizontal = () => {
        const enabled = horizontalEnabled();
        const desktop = window.innerWidth > 990;
        const header = document.querySelector('.header-section');
        const stickyTop = header ? header.getBoundingClientRect().height : 72;
        const previewBar = document.getElementById('PBarNextFrameWrapper');
        const bottomInset = previewBar ? Math.max(0, window.innerHeight - previewBar.getBoundingClientRect().top) : 0;
        const availableHeight = Math.max(1, window.innerHeight - stickyTop - bottomInset);

        horizontalSections.forEach((section) => {
          const viewport = section.querySelector('[data-ssdp-horizontal-viewport]');
          const track = section.querySelector('[data-ssdp-horizontal-track]');
          const progressBar = section.querySelector('[data-ssdp-horizontal-progress]');
          const sticky = section.querySelector('.ssdp-horizontal__sticky');
          const heading = section.parentElement.querySelector('.ssdp-heading--rail');
          if (heading && sticky) {
            if (desktop) sticky.prepend(heading);
            else section.before(heading);
          }
          section.classList.remove('is-scroll-linked');
          section.style.height = '';
          section.removeAttribute('data-ssdp-horizontal-distance');
          ['--ssdp-horizontal-scale', '--ssdp-horizontal-top', '--ssdp-horizontal-height'].forEach((property) => section.style.removeProperty(property));
          if (track) {
            track.style.transform = '';
            track.style.removeProperty('--ssdp-card-title-height');
          }
          if (viewport) viewport.style.removeProperty('--ssdp-rail-gutter');
          if (progressBar) progressBar.style.transform = '';
        });

        if (desktop) {
          // Fit the complete group, using one scale for both rails and equal edge clearance.
          let scale = 1;
          for (let pass = 0; pass < 16; pass += 1) {
            horizontalSections.forEach((section) => {
              section.style.setProperty('--ssdp-horizontal-scale', String(scale));
              const track = section.querySelector('[data-ssdp-horizontal-track]');
              const titles = Array.from(track.querySelectorAll('.ssdp-feature-card > h3, .ssdp-feature-card__title-row h3'));
              track.style.setProperty('--ssdp-card-title-height', `${Math.max(0, ...titles.map((title) => title.getBoundingClientRect().height))}px`);
            });
            if (!enabled) break;
            const tallestGroup = Math.max(...horizontalSections.map((section) => {
              const heading = section.querySelector('.ssdp-heading--rail');
              const viewport = section.querySelector('[data-ssdp-horizontal-viewport]');
              return heading.getBoundingClientRect().height + parseFloat(window.getComputedStyle(heading).marginBottom) + viewport.getBoundingClientRect().height;
            }));
            if (tallestGroup <= availableHeight - 48 || pass === 15) break;
            scale *= Math.max(1, availableHeight - 50) / tallestGroup;
          }
        }

        horizontalSections.forEach((section) => {
          const viewport = section.querySelector('[data-ssdp-horizontal-viewport]');
          const track = section.querySelector('[data-ssdp-horizontal-track]');
          if (!viewport || !track) return;

          const firstCard = track.querySelector('.ssdp-feature-card');
          const cardWidth = firstCard ? firstCard.getBoundingClientRect().width : 0;
          const minimumGutter = window.innerWidth <= 700 ? 16 : 24;
          const centeredGutter = Math.max(minimumGutter, (viewport.clientWidth - cardWidth) / 2);
          viewport.style.setProperty('--ssdp-rail-gutter', `${centeredGutter}px`);
          viewport.scrollLeft = 0;
          if (!enabled) return;

          const distance = Math.max(0, track.scrollWidth - viewport.clientWidth);
          const travel = Math.max(window.innerHeight * .62, distance * .82);
          section.dataset.ssdpHorizontalDistance = String(distance);
          // Keep the group centered while pinned without adding blank space
          // to the section's entry and exit. Outer section padding owns that gap.
          const heading = section.querySelector('.ssdp-heading--rail');
          const groupHeight = heading.getBoundingClientRect().height
            + parseFloat(window.getComputedStyle(heading).marginBottom)
            + viewport.getBoundingClientRect().height;
          const centeredTop = stickyTop + Math.max(0, (availableHeight - groupHeight) / 2);
          section.style.setProperty('--ssdp-horizontal-top', `${centeredTop}px`);
          section.style.setProperty('--ssdp-horizontal-height', `${groupHeight}px`);
          section.style.height = `${groupHeight + travel}px`;
          section.classList.add('is-scroll-linked');
        });
        queueHorizontalUpdate();
      };

      window.addEventListener('scroll', queueHorizontalUpdate, { passive: true });
      const queueHorizontalMeasure = () => {
        window.clearTimeout(resizeTimer);
        resizeTimer = window.setTimeout(measureHorizontal, 120);
      };
      window.addEventListener('resize', queueHorizontalMeasure, { passive: true });
      window.addEventListener('load', queueHorizontalMeasure, { once: true });
      const previewResize = new ResizeObserver(queueHorizontalMeasure);
      const watchPreviewBar = () => {
        const previewBar = document.getElementById('PBarNextFrameWrapper');
        if (!previewBar) return;
        previewResize.observe(previewBar);
        previewChanges.disconnect();
        queueHorizontalMeasure();
      };
      const previewChanges = new MutationObserver(watchPreviewBar);
      previewChanges.observe(document.body, { childList: true });
      watchPreviewBar();
      if (typeof reducedMotion.addEventListener === 'function') reducedMotion.addEventListener('change', measureHorizontal);
      window.requestAnimationFrame(measureHorizontal);
      if (document.fonts && document.fonts.ready) document.fonts.ready.then(measureHorizontal);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["planner-landing-page"] && !Shopify.designMode) return;
  try {
    

  function initializePlannerTour(root) {
    const tour = root.querySelector('[data-planner-tour]');
    if (!tour) return;
    const stage = tour.querySelector('.sslp-tour-stage');
    const tabs = [...tour.querySelectorAll('[data-tour-tab]')];
    const panels = [...tour.querySelectorAll('[data-tour-panel]')];
    const desktop = window.matchMedia('(min-width: 990px)');
    const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
    const header = root.querySelector('.sslp-header');
    const insideLink = root.querySelector('a[href="#inside-the-planner"]');
    const controller = new AbortController();
    const { signal } = controller;
    let frame = 0, active = -1, start = 0, step = 400, hold = 0, initialScale = .9, entryLead = 160;
    let expanded = false, expansion = null;
    const clamp = value => Math.max(0, Math.min(1, value));
    const fitPreview = () => {
      if (!desktop.matches || active < 0) return;
      const sheet = panels[active].querySelector('.sslp-tour-sheet');
      const planner = sheet.querySelector('.sslp-planner');
      sheet.style.setProperty('--preview-scale', Math.min(1, sheet.clientHeight / Math.max(1, planner.offsetHeight)).toFixed(4));
    };
    const activate = (index, focus = false) => {
      if (index !== active) {
        active = index;
        tour.dataset.tourView = tabs[index].dataset.tourTab;
        tabs.forEach((tab, i) => {
          tab.setAttribute('aria-selected', String(i === index));
          tab.tabIndex = i === index ? 0 : -1;
          panels[i].hidden = i !== index;
        });
        fitPreview();
      }
      if (focus) tabs[index].focus({ preventScroll: true });
      if (!desktop.matches) {
        const rail = tabs[index].parentElement;
        rail.scrollTo({ left: tabs[index].offsetLeft - rail.offsetLeft - (rail.clientWidth - tabs[index].offsetWidth) / 2, behavior: reduced.matches ? 'instant' : 'smooth' });
      }
      if (!tour.hasAttribute('data-scroll-tour')) {
        tour.style.setProperty('--tour-progress', (index + 1) / tabs.length);
        tour.style.setProperty('--tour-gradient-x', (-75 * index / Math.max(1, tabs.length - 1)).toFixed(4) + '%');
      }
    };
    const update = (animateEntry = true) => {
      frame = 0;
      if (!tour.hasAttribute('data-scroll-tour')) return;
      const position = window.scrollY - start;
      const nextExpanded = position >= -entryLead - (expanded ? 48 : 0) && position < hold - (expanded ? 0 : 48);
      const scale = nextExpanded ? 1 : initialScale;
      if (nextExpanded !== expanded) {
        const before = stage.getBoundingClientRect();
        expansion?.cancel();
        expansion = null;
        expanded = nextExpanded;
        tour.toggleAttribute('data-tour-expanded', expanded);
        tour.style.setProperty('--tour-scale', scale.toFixed(4));
        const bottomAnchored = position >= hold - 48;
        tour.style.setProperty('--tour-origin', bottomAnchored ? 'center bottom' : 'center top');
        const after = stage.getBoundingClientRect();
        if (animateEntry) {
          const shift = bottomAnchored ? before.bottom - after.bottom : before.top - after.top;
          const animation = stage.animate([
            { transform: `translate3d(0, ${shift}px, 0) scale(${before.width / stage.offsetWidth})` },
            { transform: `translate3d(0, 0, 0) scale(${scale})` }
          ], { duration: 900, easing: 'cubic-bezier(.22,.75,.18,1)' });
          expansion = animation;
          animation.onfinish = () => { if (expansion === animation) expansion = null; };
        }
      } else {
        tour.style.setProperty('--tour-scale', scale.toFixed(4));
        tour.style.setProperty('--tour-origin', position >= hold - 48 ? 'center bottom' : 'center top');
      }
      const movement = clamp(position / (step * Math.max(1, tabs.length - 1)));
      tour.style.setProperty('--tour-gradient-x', (-75 * movement).toFixed(4) + '%');
      root.toggleAttribute('data-tour-active', expanded);
      tour.style.setProperty('--tour-progress', clamp((position + step) / (hold + step)).toFixed(4));
      const index = Math.max(0, Math.min(tabs.length - 1, Math.floor(position / step)));
      // Keep a keyboard reader's focused panel available until focus leaves it.
      if (!panels[active]?.contains(document.activeElement)) activate(index);
    };
    const schedule = () => { if (!frame) frame = requestAnimationFrame(() => update()); };
    const measure = () => {
      expansion?.cancel();
      expansion = null;
      if (!desktop.matches || reduced.matches || window.innerHeight < 640) {
        expanded = false;
        tour.removeAttribute('data-tour-expanded');
        tour.removeAttribute('data-scroll-tour');
        tour.style.height = '';
        root.removeAttribute('data-tour-active');
        if (desktop.matches) { activate(Math.max(0, active)); fitPreview(); }
        return;
      }
      const previousPosition = expanded ? (window.scrollY - start) / step : null;
      const top = 24;
      tour.style.setProperty('--tour-top', top + 'px');
      tour.setAttribute('data-scroll-tour', '');
      const height = window.innerHeight - top - 24;
      tour.style.setProperty('--tour-height', height + 'px');
      step = Math.max(340, Math.min(600, height * .65));
      hold = (tabs.length - .45) * step;
      entryLead = Math.min(160, height * .2);
      initialScale = Math.min(.96, Math.max(.64, 1180 / stage.offsetWidth));
      tour.style.setProperty('--tour-scale', initialScale.toFixed(4));
      tour.style.setProperty('--tour-origin', 'center top');
      tour.style.height = Math.ceil(height + hold) + 'px';
      start = tour.getBoundingClientRect().top + window.scrollY - top;
      if (previousPosition !== null) window.scrollTo({ top: start + previousPosition * step, behavior: 'instant' });
      update(false);
      fitPreview();
    };
    const select = (index, focus = false) => {
      activate(index, focus);
      if (tour.hasAttribute('data-scroll-tour')) window.scrollTo({ top: start + index * step + step * .15, behavior: 'instant' });
      schedule();
    };
    tabs.forEach((tab, index) => {
      tab.addEventListener('click', () => select(index), { signal });
      tab.addEventListener('keydown', event => {
        let next;
        if (event.key === 'ArrowRight') next = (index + 1) % tabs.length;
        else if (event.key === 'ArrowLeft') next = (index + tabs.length - 1) % tabs.length;
        else if (event.key === 'Home') next = 0;
        else if (event.key === 'End') next = tabs.length - 1;
        else return;
        event.preventDefault();
        select(next, true);
      }, { signal });
    });
    insideLink?.addEventListener('click', event => {
      if (!desktop.matches) return;
      event.preventDefault();
      const destination = tour.getBoundingClientRect().top + window.scrollY - 24;
      window.scrollTo({ top: destination, behavior: reduced.matches ? 'instant' : 'smooth' });
    }, { signal });
    window.addEventListener('scroll', schedule, { passive: true, signal });
    window.addEventListener('resize', measure, { passive: true, signal });
    window.addEventListener('pageshow', measure, { signal });
    desktop.addEventListener('change', measure, { signal });
    reduced.addEventListener('change', measure, { signal });
    const observer = new ResizeObserver(measure);
    observer.observe(root.querySelector('.sslp-hero-inner'));
    observer.observe(header);
    document.fonts?.ready.then(() => { if (!signal.aborted) measure(); });
    root.closest('.shopify-section')?.addEventListener('shopify:section:unload', () => {
      controller.abort();
      observer.disconnect();
      cancelAnimationFrame(frame);
      expansion?.cancel();
    }, { once: true });
    activate(0);
    measure();
  }

  function initializePlannerStories(root) {
    const createArt = (key, title) => {
        const template = root.querySelector(`template[data-sslp-story-preview-template="${key}"]`);
        if (template) return template.content.cloneNode(true);

        const art = document.createElement('div');
        art.className = `sslp-story-preview-concept sslp-story-preview-concept--${key}`;

        const side = document.createElement('div');
        side.className = 'sslp-story-preview-concept__side';

        const heading = document.createElement('strong');
        heading.className = 'sslp-story-preview-concept__title';
        heading.textContent = title;

        const cards = document.createElement('div');
        cards.className = 'sslp-story-preview-concept__cards';
        for (let index = 0; index < 3; index += 1) cards.appendChild(document.createElement('i'));

        art.append(side, heading, cards);
        const fragment = document.createDocumentFragment();
        fragment.appendChild(art);
        return fragment;
      };

      const renderArt = (target, key, title) => {
        if (!target) return;
        target.replaceChildren(createArt(key, title));
      };
    root.querySelectorAll('[data-sslp-app]').forEach((app) => {
      const items = Array.from(app.querySelectorAll('[data-sslp-app-item]'));
      const stage = app.querySelector('[data-sslp-app-art]');
      if (!stage || !items.length) return;
      const layers = items.map((item, index) => {
        const layer = document.createElement('div');
        layer.className = `sslp-app__layer${index === 0 ? ' is-active' : ''}`;
        renderArt(layer, item.dataset.art, item.dataset.title);
        stage.appendChild(layer);
        return layer;
      });
      const mobile = window.matchMedia('(max-width: 989px)');
      const artColumn = stage.parentElement;
      const layout = app.querySelector('.sslp-app__layout');
      let activeItem = 0;
      const placeArt = () => {
        const target = mobile.matches ? items[activeItem].querySelector('.sslp-app__panel > div') : layout;
        if (artColumn.parentElement !== target) target.appendChild(artColumn);
      };
      const activate = (index) => {
        activeItem = index;
        placeArt();
        items.forEach((item, position) => {
          const active = position === index;
          item.classList.toggle('is-active', active);
          item.querySelector('button').setAttribute('aria-expanded', String(active));
          item.querySelector('.sslp-app__panel').setAttribute('aria-hidden', String(!active));
          layers[position].classList.toggle('is-active', active);
        });
      };
      items.forEach((item, index) => item.addEventListener('click', () => activate(index)));
      mobile.addEventListener('change', placeArt);
      placeArt();
      root.closest('.shopify-section')?.addEventListener('shopify:section:unload', () => {
        mobile.removeEventListener('change', placeArt);
      }, { once: true });
      const measure = () => {
        if (window.innerWidth < 990) return;
        app.style.setProperty('--sslp-app-width', `${Math.min(1200, document.documentElement.clientWidth * .9)}px`);
      };
      window.addEventListener('resize', measure, { passive: true });
      measure();
    });

    root.querySelectorAll('[data-sslp-inclusions]').forEach((section) => {
      const stage = section.querySelector('.sslp-inclusions__cards');
      const cards = Array.from(section.querySelectorAll('[data-sslp-inclusion]'));
      if (!stage || !cards.length) return;
      cards.forEach((card) => renderArt(card.querySelector('[data-sslp-inclusion-art]'), card.dataset.art, card.dataset.title));
      const controller = new AbortController();
      const measure = () => {
        if (window.innerWidth < 990) return;
        section.style.setProperty('--sslp-inclusions-width', `${Math.min(1200, document.documentElement.clientWidth * .9)}px`);
        const positionHeight = Math.min(800, window.innerWidth * .6);
        const contentHeight = Math.max(positionHeight, ...cards.map((card, index) => positionHeight * index * .18 + card.offsetHeight));
        stage.style.setProperty('--sslp-inclusions-content-height', `${Math.ceil(contentHeight)}px`);
      };
      measure();
      let observer;
      if (!window.matchMedia('(prefers-reduced-motion: reduce)').matches && 'IntersectionObserver' in window && stage.getBoundingClientRect().top > window.innerHeight) {
        stage.classList.add('is-waiting');
        observer = new IntersectionObserver((entries) => {
          if (!entries.some((entry) => entry.isIntersecting)) return;
          stage.classList.remove('is-waiting');
          observer.disconnect();
        }, { rootMargin: '0px 0px -5% 0px', threshold: 0 });
        observer.observe(stage);
      }
      window.addEventListener('resize', measure, { passive: true, signal: controller.signal });
      document.fonts?.ready.then(() => { if (!controller.signal.aborted) measure(); });
      root.closest('.shopify-section')?.addEventListener('shopify:section:unload', () => {
        controller.abort();
        observer?.disconnect();
      }, { once: true });
    });

    const verticalStories = Array.from(root.querySelectorAll('[data-sslp-story]')).map((story) => {
        const stepsRail = story.querySelector('.sslp-story__steps');
        const steps = Array.from(story.querySelectorAll('[data-sslp-step]'));
        const stage = story.querySelector('[data-sslp-story-art]');
        const stageShell = story.querySelector('.sslp-story__stage');
        const caption = story.querySelector('.sslp-story__stage-caption');
        const number = story.querySelector('[data-sslp-story-number]');
        const title = story.querySelector('[data-sslp-story-title]');
        const layers = [];
        let activeIndex = 0;
        let settleTimer = null;

        if (stage) {
          stage.replaceChildren();
          steps.forEach((step, index) => {
            const layer = document.createElement('div');
            layer.className = 'sslp-story__stage-layer';
            renderArt(layer, step.dataset.art, step.dataset.title);
            if (index === 0) layer.classList.add('is-active');
            stage.append(layer);
            layers.push(layer);
          });
        }

        const activateStep = (index) => {
          const step = steps[index];
          if (!step || index === activeIndex) return;
          const previousIndex = activeIndex;
          activeIndex = index;
          steps.forEach((item, itemIndex) => item.classList.toggle('is-active', itemIndex === activeIndex));
          layers.forEach((layer, layerIndex) => {
            layer.classList.toggle('is-active', layerIndex === activeIndex);
            layer.classList.toggle('is-exiting', layerIndex === previousIndex && layerIndex !== activeIndex);
          });
          window.clearTimeout(settleTimer);
          settleTimer = window.setTimeout(() => {
            layers.forEach((layer) => layer.classList.remove('is-exiting'));
          }, 340);
          if (number) number.textContent = step.dataset.number;
          if (title) title.textContent = step.dataset.title;
          if (caption && typeof caption.animate === 'function' && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
            caption.getAnimations().forEach((animation) => animation.cancel());
            caption.animate([
              { opacity: .2, transform: 'translate3d(0, 4px, 0)' },
              { opacity: 1, transform: 'translate3d(0, 0, 0)' }
            ], { duration: 280, easing: 'cubic-bezier(.2,.65,.3,1)' });
          }
        };

        if (steps[0]) {
          steps.forEach((step, index) => step.classList.toggle('is-active', index === 0));
          steps[0].classList.add('is-active');
        }

        return { story, steps, stepsRail, stage, stageShell, activateStep };
      });

      let verticalFrame = null;
      let verticalMeasureFrame = null;

      const measureVerticalStories = () => {
        verticalMeasureFrame = null;
        verticalStories.forEach(({ story, steps, stepsRail, stage, stageShell }) => {
          if (!stepsRail) return;
          if (window.innerWidth < 990 || !stage || !stageShell || !steps[0]) {
            stepsRail.style.removeProperty('--sslp-first-step-offset');
            stepsRail.style.removeProperty('--sslp-last-step-offset');
            return;
          }
          stepsRail.style.setProperty('--sslp-first-step-offset', '0px');
          stepsRail.style.setProperty('--sslp-last-step-offset', '0px');
          const stageHeight = stage.getBoundingClientRect().height;
          const stageShellHeight = stageShell.getBoundingClientRect().height;
          const firstStepHeight = steps[0].getBoundingClientRect().height;
          const lastStepHeight = steps[steps.length - 1].getBoundingClientRect().height;
          const firstStepOffset = Math.max(0, (stageHeight - firstStepHeight) / 2);
          const introHeight = story.querySelector('.sslp-story__intro').getBoundingClientRect().height;
          const lastStepCenter = Math.max(stageHeight / 2, introHeight + 20 + lastStepHeight / 2);
          const lastStepOffset = Math.max(0, stageShellHeight - lastStepCenter - lastStepHeight / 2);
          stepsRail.style.setProperty('--sslp-first-step-offset', `${firstStepOffset}px`);
          stepsRail.style.setProperty('--sslp-last-step-offset', `${lastStepOffset}px`);
        });
        queueVerticalUpdate();
      };

      const updateVerticalStories = () => {
        verticalFrame = null;
        if (window.innerWidth < 990) return;
        verticalStories.forEach(({ story, steps, stage, activateStep }) => {
          const storyBox = story.getBoundingClientRect();
          if (storyBox.bottom <= 0 || storyBox.top >= window.innerHeight) return;
          const stageBox = stage ? stage.getBoundingClientRect() : null;
          const introBox = story.querySelector('.sslp-story__intro').getBoundingClientRect();
          const triggerLine = stageBox && stageBox.height > 0
            ? Math.max(stageBox.top + stageBox.height * .75, introBox.bottom + 20 + steps[0].getBoundingClientRect().height / 2)
            : window.innerHeight * .75;
          let activeIndex = 0;
          steps.forEach((step, index) => {
            const stepBox = step.getBoundingClientRect();
            const stepCenter = stepBox.top + stepBox.height / 2;
            if (stepCenter <= triggerLine) activeIndex = index;
          });
          activateStep(activeIndex);
        });
      };

      const queueVerticalUpdate = () => {
        if (verticalFrame !== null) return;
        verticalFrame = window.requestAnimationFrame(updateVerticalStories);
      };

      const queueVerticalMeasure = () => {
        if (verticalMeasureFrame !== null) return;
        verticalMeasureFrame = window.requestAnimationFrame(measureVerticalStories);
      };

      window.addEventListener('scroll', queueVerticalUpdate, { passive: true });
      window.addEventListener('resize', queueVerticalMeasure, { passive: true });
      window.requestAnimationFrame(measureVerticalStories);
      if (document.fonts && document.fonts.ready) document.fonts.ready.then(queueVerticalMeasure);
  }

  function initializePlannerStyles(root) {
    const section = root.querySelector('[data-sslp-style]');
    const preview = section?.querySelector('[data-style-preview]');
    if (!preview) return;
    const targets = { theme: '.sslp-planner', cover: '.sslp-cover', background: '.sslp-style-backdrop' };
    section.querySelectorAll('[data-style-group]').forEach((group) => {
      const kind = group.dataset.styleGroup;
      const buttons = Array.from(group.querySelectorAll('[data-style-choice]'));
      const selected = group.querySelector('[data-style-selected]');
      const activate = (button, focus = false) => {
        if (focus) button.focus();
        if (preview.dataset[kind] === button.dataset.styleChoice) return;
        preview.dataset[kind] = button.dataset.styleChoice;
        buttons.forEach((option) => {
          const active = option === button;
          option.setAttribute('aria-checked', String(active));
          option.tabIndex = active ? 0 : -1;
        });
        selected.textContent = button.getAttribute('aria-label');
        const target = preview.querySelector(targets[kind]);
        if (target?.animate && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
          target.getAnimations().forEach((animation) => animation.cancel());
          target.animate([{ opacity: .65 }, { opacity: 1 }], { duration: 220, easing: 'ease-out' });
        }
      };
      buttons.forEach((button, index) => {
        button.addEventListener('click', () => activate(button));
        button.addEventListener('keydown', (event) => {
          let next = index;
          if (event.key === 'ArrowRight' || event.key === 'ArrowDown') next = (index + 1) % buttons.length;
          else if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') next = (index - 1 + buttons.length) % buttons.length;
          else if (event.key === 'Home') next = 0;
          else if (event.key === 'End') next = buttons.length - 1;
          else return;
          event.preventDefault();
          activate(buttons[next], true);
        });
      });
    });
  }

  function initializePlannerLanding(scope) {
    const root = scope.matches?.('[data-sslp]') ? scope : scope.querySelector('[data-sslp]');
    if (!root || root.dataset.enhanced) return;
    root.dataset.enhanced = 'true';
    const tabs = [...root.querySelectorAll('[data-view-tab]')];
    const panels = [...root.querySelectorAll('[data-view-panel]')];
    const activate = (index, focus = false) => {
      tabs.forEach((tab, position) => {
        const active = position === index;
        tab.setAttribute('aria-selected', String(active));
        tab.tabIndex = active ? 0 : -1;
      });
      panels.forEach(panel => { panel.hidden = panel.dataset.viewPanel !== tabs[index].dataset.viewTab; });
      if (focus) tabs[index].focus();
    };
    tabs.forEach((tab, index) => {
      tab.addEventListener('click', () => activate(index));
      tab.addEventListener('keydown', event => {
        let next = index;
        if (event.key === 'ArrowRight') next = (index + 1) % tabs.length;
        else if (event.key === 'ArrowLeft') next = (index + tabs.length - 1) % tabs.length;
        else if (event.key === 'Home') next = 0;
        else if (event.key === 'End') next = tabs.length - 1;
        else return;
        event.preventDefault();
        activate(next, true);
      });
    });
    if (tabs.length) activate(0);
    initializePlannerTour(root);
    initializePlannerStories(root);
    initializePlannerStyles(root);

  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initializePlannerLanding(document), { once: true });
  else initializePlannerLanding(document);
  document.addEventListener('shopify:section:load', event => initializePlannerLanding(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["slate-homepage-refresh"] && !Shopify.designMode) return;
  try {
    

  document.querySelectorAll('[data-ss-home-gallery]').forEach((gallery) => {
    if (gallery.dataset.galleryReady === 'true') return;
    gallery.dataset.galleryReady = 'true';

    const mainImage = gallery.querySelector('[data-ss-home-gallery-main]');
    const thumbnails = gallery.querySelectorAll('[data-ss-home-gallery-thumb]');

    thumbnails.forEach((thumbnail) => {
      thumbnail.addEventListener('click', () => {
        if (!mainImage || thumbnail.classList.contains('is-active')) return;

        thumbnails.forEach((item) => {
          item.classList.remove('is-active');
          item.setAttribute('aria-pressed', 'false');
        });
        thumbnail.classList.add('is-active');
        thumbnail.setAttribute('aria-pressed', 'true');

        const nextImage = new Image();
        nextImage.src = thumbnail.dataset.imageSrc;
        nextImage.alt = thumbnail.dataset.imageAlt || '';
        mainImage.style.opacity = '0';

        nextImage.addEventListener('load', () => {
          mainImage.removeAttribute('srcset');
          mainImage.removeAttribute('sizes');
          mainImage.src = nextImage.src;
          mainImage.alt = nextImage.alt;
          mainImage.style.opacity = '1';
        });
      });
    });
  });


(() => {
  const init = scope => {
    scope.querySelectorAll('[data-home-section]:not([data-enhanced])').forEach(root => {
      const tablist = root.querySelector('[data-home-tabs]');
      if (tablist) {
        const tabs = Array.from(root.querySelectorAll('[data-home-tab]'));
        const panels = Array.from(root.querySelectorAll('[data-home-panel]'));
        const select = index => tabs.forEach((tab,i) => {
          tab.setAttribute('aria-selected',String(i === index));
          tab.tabIndex = i === index ? 0 : -1;
          panels[i].hidden = i !== index;
          panels[i].inert = i !== index;
          panels[i].setAttribute('aria-hidden',String(i !== index));
        });
        tablist.setAttribute('role','tablist');
        tabs.forEach((tab,index) => {
          tab.setAttribute('role','tab');
          panels[index].setAttribute('role','tabpanel');
          panels[index].tabIndex = 0;
          tab.addEventListener('click',() => select(index));
          tab.addEventListener('keydown',event => {
            let next = index;
            if (event.key === 'ArrowRight') next = (index + 1) % tabs.length;
            else if (event.key === 'ArrowLeft') next = (index + tabs.length - 1) % tabs.length;
            else if (event.key === 'Home') next = 0;
            else if (event.key === 'End') next = tabs.length - 1;
            else return;
            event.preventDefault(); select(next); tabs[next].focus();
          });
        });
        select(0);
      }
      const style = root.querySelector('[data-home-style]');
      if (style) {
        const art = style.querySelector('.sshm-style-art');
        style.querySelectorAll('[data-home-style-group]').forEach(group => {
          group.addEventListener('change',event => {
            const input = event.target;
            if (!(input instanceof HTMLInputElement) || !input.checked) return;
            const kind = group.dataset.homeStyleGroup;
            art.setAttribute('data-home-'+kind,input.value);
            group.querySelector('[data-home-selected]').textContent = input.getAttribute('aria-label');
          });
        });
      }
      root.dataset.enhanced = '';
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',() => init(document),{once:true});
  else init(document);
  document.addEventListener('shopify:section:load',event => init(event.target));
})();

(() => {
  const init = scope => scope.querySelectorAll('[data-page-gallery]:not([data-gallery-ready])').forEach(root => {
    const wire = (list, tabs, panels) => {
      if (!list || !tabs.length || tabs.length !== panels.length) return;
      const select = index => {
        tabs.forEach((tab,i) => {
          tab.setAttribute('aria-selected',String(i === index));
          tab.tabIndex = i === index ? 0 : -1;
          panels[i].hidden = i !== index;
          panels[i].inert = i !== index;
          panels[i].setAttribute('aria-hidden',String(i !== index));
        });
      };
      list.setAttribute('role','tablist');
      tabs.forEach((tab,index) => {
        tab.setAttribute('role','tab');
        panels[index].setAttribute('role','tabpanel');
        panels[index].tabIndex = 0;
        tab.addEventListener('click',() => select(index));
        tab.addEventListener('keydown',event => {
          let next;
          if (event.key === 'ArrowRight') next = (index+1)%tabs.length;
          else if (event.key === 'ArrowLeft') next = (index+tabs.length-1)%tabs.length;
          else if (event.key === 'Home') next = 0;
          else if (event.key === 'End') next = tabs.length-1;
          else return;
          event.preventDefault();select(next);tabs[next].focus();
        });
      });
      select(0);
    };
    const groups = Array.from(root.querySelectorAll('[data-gallery-panel]'));
    wire(root.querySelector('[data-gallery-tabs]'),Array.from(root.querySelectorAll('[data-gallery-tab]')),groups);
    groups.forEach(group => wire(group.querySelector('[data-page-tabs]'),Array.from(group.querySelectorAll('[data-page-tab]')),Array.from(group.querySelectorAll('[data-page-panel]'))));
    root.dataset.galleryReady = '';
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',() => init(document),{once:true});
  else init(document);
  document.addEventListener('shopify:section:load',event => init(event.target));
})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["slate-homepage"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-ss-home-gallery]').forEach((gallery) => {
    if (gallery.dataset.galleryReady === 'true') return;
    gallery.dataset.galleryReady = 'true';

    const mainImage = gallery.querySelector('[data-ss-home-gallery-main]');
    const thumbnails = gallery.querySelectorAll('[data-ss-home-gallery-thumb]');

    thumbnails.forEach((thumbnail) => {
      thumbnail.addEventListener('click', () => {
        if (!mainImage || thumbnail.classList.contains('is-active')) return;

        thumbnails.forEach((item) => {
          item.classList.remove('is-active');
          item.setAttribute('aria-pressed', 'false');
        });
        thumbnail.classList.add('is-active');
        thumbnail.setAttribute('aria-pressed', 'true');

        const nextImage = new Image();
        nextImage.src = thumbnail.dataset.imageSrc;
        nextImage.alt = thumbnail.dataset.imageAlt || '';
        mainImage.style.opacity = '0';

        nextImage.addEventListener('load', () => {
          mainImage.removeAttribute('srcset');
          mainImage.removeAttribute('sizes');
          mainImage.src = nextImage.src;
          mainImage.alt = nextImage.alt;
          mainImage.style.opacity = '1';
        });
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["slate-planner-circle"] && !Shopify.designMode) return;
  try {
    
(() => {
  const init = scope => scope.querySelectorAll('[data-planner-circle]:not([data-enhanced])').forEach(root => {
    root.dataset.enhanced = '';
    const result = root.querySelector('.sspc-form-success, .sspc-form-errors');
    if (result) result.focus();
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(document), {once:true});
  else init(document);
  document.addEventListener('shopify:section:load', event => init(event.target));
})();

  } catch(e) { console.error(e); }
})();
})();
